import React, { useCallback, useEffect } from "react";
import { ReactComponent as Close } from "assets/svgs/close.svg";
import { ReactComponent as Search } from "assets/svgs/search.svg";
import { useDispatch, useSelector } from "react-redux";
import debounce from "helpers/debounce";
import { trackSearchProducts } from "services/analytics";
import { useGlobalContext } from "context/global";
import clsx from "clsx/lite";
import { cartMeals } from "utils/constants";
import { setSearch, toggleSearch } from "slices/filters";

const SearchProducts = ({ hideInDesktop = false }) => {
	const { isSearchOpen, search } = useSelector(state => state.filters);
	const { view } = useSelector(state => state.global);
	const { isSubscriptionPage, translation } = useGlobalContext();
	const dispatch = useDispatch();

	const clearSearch = () => {
		dispatch(toggleSearch());
		dispatch(setSearch(""));
	};

	useEffect(() => {
		dispatch(setSearch(""));
	}, []);

	const handleChange = (e) => {
		const searchText = e.target.value;
		dispatch(setSearch(searchText));
		searchText && debouncedResults(searchText);
	};

	const debouncedResults = useCallback(debounce((text) => trackSearchProducts(text), 1000), []);
	const disabled = view === cartMeals;

	return isSearchOpen ? (
		<div className={clsx("flex items-center px-1 z-30 bg-white w-full", hideInDesktop && "lg:hidden")}>
			<Search className={clsx(isSubscriptionPage && "size-5 lg:size-7")} />
			<input
				autoFocus
				onKeyDown={(e) => e.key === "Escape" && clearSearch()}
				onChange={handleChange}
				value={search}
				aria-label={translation.collection.search_products}
				className={clsx("w-full border-black focus:outline-none", isSubscriptionPage ? "mt-2 mx-2" : "m-2 border-b-[1px] ")}
				type="text" placeholder="Search..." />
			<button className="animate-fade-in"
				onClick={clearSearch}
				aria-label="Clear search">
				<Close className="w-5 h-5 cursor-pointer" />
			</button>
		</div>
	) : (
		<button className={clsx("animate-fade-in mx-3 md:mx-0 relative self-center mt-2", hideInDesktop && "lg:hidden")}
			onClick={() => !disabled && dispatch(toggleSearch())}
			aria-label="Open search">
			<Search
				className={clsx(
					isSubscriptionPage && "size-5 lg:size-7", disabled ? "opacity-30 pointer-events-none" : "cursor-pointer")}
			/>
		</button>
	);
};

export default SearchProducts;
